import styled, { keyframes } from 'styled-components';

export const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: #0a0a0a;
`;

export const GameContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 16px;
  position: relative;
  overflow: hidden;
`;

export const Button = styled.button`
  position: relative;
  z-index: 2; /* 버튼을 위로 올리기 위해 추가 */
  padding: 12px 24px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 600;
  color: white;
  background: linear-gradient(45deg, #ff4757, #ff6b81);
  box-shadow: 0 4px 12px rgba(255, 71, 87, 0.3);
  transition: all 0.2s ease;
  margin: 8px 0;
  width: 100%;
  max-width: 280px;

  &:active {
    transform: scale(0.98);
    box-shadow: 0 2px 8px rgba(255, 71, 87, 0.3);
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: white;
  margin-bottom: 24px;
  text-align: center;
  text-shadow: 0 0 10px rgba(255, 71, 87, 0.7);
`;

export const ScoreText = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 8px 0;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
`;

export const GameBoard = styled.div`
  width: 100%;
  height: 70%;
  position: relative;
  overflow: hidden;
  background: linear-gradient(to bottom, #1e272e, #485460);
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
`;

const runAnimation = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: -300px 0; }
`;

export const Character = styled.div<{ isJumping: boolean; isSliding: boolean }>`
  width: 60px;
  height: ${props => (props.isSliding ? '30px' : '60px')};
  position: absolute;
  left: 50px;
  bottom: ${props => (props.isJumping ? '120px' : props.isSliding ? '0' : '0')};
  background-color: #ff4757;
  border-radius: 8px;
  transition: bottom 0.3s ease, height 0.2s ease;
  z-index: 10;
  background-image: url('/ninja-sprite.png');
  background-size: 300px 60px;
  animation: ${runAnimation} 0.5s steps(5) infinite;
`;

export const Obstacle = styled.div<{ position: number; height: number }>`
  width: 30px;
  height: ${props => props.height}px;
  position: absolute;
  left: ${props => props.position}px;
  bottom: 0;
  background-color: #2e86de;
  border-radius: 4px;
`;

export const Enemy = styled.div<{ position: number }>`
  width: 40px;
  height: 40px;
  position: absolute;
  left: ${props => props.position}px;
  bottom: 0;
  background-color: #8854d0;
  border-radius: 50%;
`;

export const Item = styled.div<{ position: number; type: string }>`
  width: 20px;
  height: 20px;
  position: absolute;
  left: ${props => props.position}px;
  bottom: 40px;
  background-color: ${props => (props.type === 'coin' ? '#feca57' : '#1dd1a1')};
  border-radius: ${props => (props.type === 'coin' ? '50%' : '4px')};
  box-shadow: 0 0 10px ${props => (props.type === 'coin' ? '#feca57' : '#1dd1a1')};
`;

export const Projectile = styled.div<{ position: { x: number; y: number } }>`
  width: 15px;
  height: 5px;
  position: absolute;
  left: ${props => props.position.x}px;
  bottom: ${props => props.position.y}px;
  background-color: #ff9ff3;
  border-radius: 2px;
`;

export const ScoreBoard = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  display: flex;
  flex-direction: column;
  z-index: 20;
`;

export const SpecialBar = styled.div`
  width: 100px;
  height: 10px;
  background-color: #222;
  border-radius: 5px;
  margin-top: 8px;
  overflow: hidden;
`;

export const SpecialBarFill = styled.div<{ width: number }>`
  width: ${props => props.width}%;
  height: 100%;
  background: linear-gradient(to right, #ff9ff3, #feca57);
  border-radius: 5px;
  transition: width 0.3s ease;
`;

export const PauseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  z-index: 20;
`;

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 30;
`;

export const ResultScore = styled.h2`
  font-size: 48px;
  font-weight: 800;
  color: #ff4757;
  margin: 16px 0;
  text-shadow: 0 0 10px rgba(255, 71, 87, 0.7);
`;

export const ResultText = styled.p`
  font-size: 18px;
  font-weight: 600;
  color: white;
  margin: 8px 0;
  text-align: center;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px;
`;

export const SettingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 280px;
  margin: 8px 0;
`;

export const SettingsLabel = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: white;
`;

export const ToggleSwitch = styled.div<{ isOn: boolean }>`
  width: 48px;
  height: 24px;
  background-color: ${props => (props.isOn ? '#ff4757' : '#485460')};
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:after {
    content: '';
    position: absolute;
    top: 2px;
    left: ${props => (props.isOn ? '26px' : '2px')};
    width: 20px;
    height: 20px;
    background-color: white;
    border-radius: 50%;
    transition: left 0.2s ease;
  }
`;

export const ShopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px;
  overflow-y: auto;
`;

export const ShopItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 320px;
  padding: 12px;
  margin: 8px 0;
  background-color: #1e272e;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`;

export const ShopItemImage = styled.div`
  width: 50px;
  height: 50px;
  background-color: #ff4757;
  border-radius: 8px;
  margin-right: 12px;
`;

export const ShopItemInfo = styled.div`
  flex: 1;
`;

export const ShopItemTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: white;
  margin-bottom: 4px;
`;

export const ShopItemDescription = styled.p`
  font-size: 12px;
  color: #d2dae2;
`;

export const ShopItemPrice = styled.div`
  display: flex;
  align-items: center;
  color: #feca57;
  font-weight: 600;
`;

export const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 100%;
  background-image: url('/background.png');
  background-repeat: repeat-x;
  background-size: 50% 100%;
  animation: scrollBackground 20s linear infinite;
  z-index: 1;
  pointer-events: none; /* 터치 이벤트가 이 요소에서 차단되지 않도록 추가 */

  @keyframes scrollBackground {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
`;

export const Ground = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 200%;
  height: 20px;
  background-image: url('/ground.png');
  background-repeat: repeat-x;
  background-size: 50% 100%;
  animation: scrollGround 10s linear infinite;
  z-index: 2;
  pointer-events: none; /* 터치 이벤트가 이 요소에서 차단되지 않도록 추가 */

  @keyframes scrollGround {
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
  }
`;

export const TutorialOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 40;
  padding: 24px;
  text-align: center;
`;

export const TutorialText = styled.p`
  font-size: 18px;
  color: white;
  margin: 16px 0;
  line-height: 1.5;
`;

export const TutorialImage = styled.div`
  width: 200px;
  height: 100px;
  background-color: #485460;
  border-radius: 8px;
  margin: 16px 0;
`;
